import CustomSwitchGraphicsModal from './CustomSwitchGraphicsModal'

export default CustomSwitchGraphicsModal
